export function hexToRgba(color, alpha) {
  if (!color?.startsWith("#")) return color;
  const normalized = color.length === 4
    ? `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`
    : color;
  const value = normalized.slice(1);
  const red = Number.parseInt(value.slice(0, 2), 16);
  const green = Number.parseInt(value.slice(2, 4), 16);
  const blue = Number.parseInt(value.slice(4, 6), 16);
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}

export function drawFlowCurve(ctx, x0, y0, x1, y1, cp1x, cp2x) {
  ctx.beginPath();
  ctx.moveTo(x0, y0);
  ctx.bezierCurveTo(cp1x, y0, cp2x, y1, x1, y1);
}

export function roundRectPath(ctx, x, y, width, height, radius) {
  ctx.beginPath();
  appendRoundRectPath(ctx, x, y, width, height, radius);
}

export function appendRoundRectPath(ctx, x, y, width, height, radius) {
  const bounded = Math.max(0, Math.min(radius, width / 2, height / 2));
  ctx.moveTo(x + bounded, y);
  ctx.lineTo(x + width - bounded, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + bounded);
  ctx.lineTo(x + width, y + height - bounded);
  ctx.quadraticCurveTo(x + width, y + height, x + width - bounded, y + height);
  ctx.lineTo(x + bounded, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - bounded);
  ctx.lineTo(x, y + bounded);
  ctx.quadraticCurveTo(x, y, x + bounded, y);
  ctx.closePath();
}
